import React, { useEffect } from "react";
import { Routes, Route, BrowserRouter, useNavigate } from 'react-router-dom';
import cookie from 'react-cookies';

import Scalculator from "./scalculator";
import SignUp from "./sign/up";
import SignIn from "./sign/in";
import useGlobal from "../../store";
import Tariff from "./tariff";
import PaymentResult from "./payment.result";


const AppRouter = () => {
  
  return(

    <BrowserRouter>

      <Routes>

        <Route path = "/"        element = { <Protected subscribe><Scalculator /></Protected>}/>
        <Route path = "/signup"  element = { <SignUp />}/>
        <Route path = "/signin"  element = { <SignIn />}/>
        <Route path = "/history" element = { <Protected subscribe><Scalculator /></Protected>}/>
        <Route path = "/deals"   element = { <Protected><Scalculator /></Protected>}/>
        <Route exact path = "/tariff" element = { <Protected><Tariff /></Protected> }/>
        <Route exact path = "/payment" element = { <Protected><PaymentResult /></Protected> }/>

      </Routes>
      
    </BrowserRouter>

  );

}

const Protected = ({ children, subscribe = false }) => {

	const [ globalState, globalActions ] = useGlobal();
  const navigate = useNavigate();
	const token = cookie.load('token');

	useEffect(() => { 

    console.log(`Protected token = `, token);
		
		token 
			? globalActions.sign.Check( token, subscribe, navigate )
			: globalActions.sign.Out()
	
	}, []);

	return children;

}

export default AppRouter;